/* eslint-disable no-param-reassign */
import { samplesApi } from '@/api';

const openInsertMeasuredValue = async (component, row) => {
  try {
    const sampleResponse = await samplesApi.show(row.sampleId);
    component.selectedSample = sampleResponse.data;
    component.selectedOperationId = row.operationRegistryId;
    component.selectedSampleAnalysisId = row.labSampleAnalysisId;
    component.currentValues = row.value ? { ...row.value } : null;
    component.currentOperation = row;
    component.measuredValueModal = true;
  } catch (error) {
    component.$notify({
      showClose: true,
      type: 'error',
      message: error.response.data.error.message,
    });
  }
};

const openInsertMeasuredValueBulk = async (component, row) => {
  try {
    const sampleResponse = await samplesApi.show(row.sampleId);
    component.selectedSample = sampleResponse.data;
    component.selectedAnalysis = { ...row };
    component.measuredValueModalBulk = true;
  } catch (error) {
    component.$notify({
      showClose: true,
      type: 'error',
      message: error.response.data.error.message,
    });
  }
};

const openCreateTemperatureTrail = async (component, row) => {
  // if (row.children) {
  //   component.temperatureTrailAnalysisIds = Array.from(
  //     new Set(row.children.map((c) => c.sampleAnalysisId)),
  //   );
  // } else {
  component.temperatureTrailAnalysisIds = row.labSampleAnalysisId;
  // }
  component.temperatureTrailModal = true;
};

const enableDisableRawData = async (component, row) => {
  const value = row.value ? { ...row.value } : null;
  if (value) {
    try {
      await samplesApi.updateSampleOperationValues(value.id, {
        showRawData: !row.value.showRawData,
      });
      component.tableRows();
      component.$notify({
        showClose: true,
        type: 'success',
        message: component.$t('global.success'),
      });
    } catch (error) {
      component.$notify({
        showClose: true,
        type: 'error',
        message: error.response.data.error.message,
      });
    }
  }
};

const handleDialogClose = (component, status) => {
  component.selectedOperationId = null;
  component.selectedSampleAnalysisId = null;
  component.currentValues = null;
  component.selectedSample = null;
  component.selectedAnalysis = null;
  component.measuredValueModal = false;
  component.measuredValueModalBulk = false;
  component.temperatureTrailAnalysisIds = null;
  component.temperatureTrailModal = false;
  if (status.success) component.tableRows();
};

const prepareTableData = (component, sampleAnalysesMulti) => {
  component.tableKeysWithSamples = [];
  sampleAnalysesMulti.data.forEach((sampleWithAnalyses) => {
    const sampleId = sampleWithAnalyses.sample.id;
    const { productName, labSampleCode, laboratory } =
      sampleWithAnalyses.sample;
    const tableKey = `sampleDetails_${sampleId}`;

    component.addTable({ tableKey });
    component.tableKeysWithSamples.push({
      tableKey,
      productName,
      labSampleCode,
    });

    const tableData = sampleWithAnalyses.analyses.map((item) => {
      const mainOperation = item.operationsWithValues.find(
        (op) => op?.mainResult === true
      );

      const sampleData = {
        tableId: item.id,
        sampleId,
        laboratory,
        ...item,
      };
      if (mainOperation) {
        sampleData.measure = mainOperation.measureId
          ? {
              id: mainOperation.measureId,
              description: mainOperation.measureDescription,
            }
          : null;
        sampleData.value = mainOperation.value
          ? { ...mainOperation.value }
          : null;
      }

      return {
        ...sampleData,
        children: item.operationsWithValues.map((operation) => ({
          sampleId,
          labSampleAnalysisId: item.labSampleAnalysisId,
          laboratory,
          tableId: `${item.id}.${operation.operationRegistryId}.`,
          ...operation,
          description: operation.operation,
          mainOpMeasure: sampleData.measure || null,
        })),
      };
    });
    component.updateTableRows({ tableKey, rows: tableData });
  });
};

/* eslint-enable no-param-reassign */

export default (component) => ({
  openInsertMeasuredValue: (row) => openInsertMeasuredValue(component, row),
  openInsertMeasuredValueBulk: (row) =>
    openInsertMeasuredValueBulk(component, row),
  openCreateTemperatureTrail: (row) =>
    openCreateTemperatureTrail(component, row),
  enableDisableRawData: (row) => enableDisableRawData(component, row),
  handleDialogClose: (status) => handleDialogClose(component, status),
  prepareTableData: (sampleAnalysesMulti) =>
    prepareTableData(component, sampleAnalysesMulti),
});
